'use strict';

const processInclude = require('base/util');

require('base/components/spinner');

$(() => {
    processInclude(require('./cart/cart'));
    processInclude(require('./cart/cartCustom'));
});
